// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9fe2fdf6","453":"5d27aea1","455":"c82e0915","977":"0a68e1fd"}[chunkId] + ".chunk.js";
};